module.exports = __webpack_public_path__ + "static/img/zhong15.944f701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong15.png
// module id = tovc
// module chunks = 16